export default "__VITE_ASSET__SHAOOHUI__"